import _ from 'lodash'

export default {
	name : 'text-field',
	props : ['data'],
	data () {
		return {
			field : {
				value : this.data.value
			}
		}
	},
	methods : {
    changeData: _.debounce(
      function (event) {

        let vm = this

        this.$emit('changeData', event.target.value)

      }, 300)
	}
}



// WEBPACK FOOTER //
// ./src/components/general/fields/text/script.js